import React from 'react';
import {
    Route,
    Switch
} from 'react-router-dom'
import App from './App';
import Agreement from './Agreement';
import Introduce from './Introduce';
import PrivacyGDPR from "./PrivacyGDPR";
import Privacy from "./Privacy";


import { injectIntl} from 'react-intl';



export default  injectIntl(class extends React.PureComponent {
   
    render() {
        // const {intl} = this.props;
        // const url = intl.locale==="tr" ?  //
        return (
            <Switch location={this.props.location} history={this.props.history} level={1} >
                <Route path="/userAgreement"   render={ props =>
                    <Agreement {...props}/>
                }/>
                 <Route path="/userIntroduce"   render={ props =>
                    <Introduce {...props}/>
                }/>
                <Route path="/privacyGDPR"   render={ props =>
                    <PrivacyGDPR {...props}/>
                }/>
                <Route path="/privacy"  render={ props =>
                    <Privacy {...props} />
                }/>
                <Route path="/"  render={ props =>
                    <App {...props} />
                }/>
              
            </Switch>
        )
    }
})